
import { B2BDealType, B2CDealType, CostDealType } from "@/app/constants";
import { IPricing } from "@/app/domain";

import { CalculationStrategy, PriceResult } from "../base/calculation.strategy";
import { ReactiveComponent } from "../../entities/base-component";

export class TaxSumCalculationStrategy extends CalculationStrategy {
    calculate(component: ReactiveComponent, [subtotal, partitionPrice, taxPercent, taxStatus]): PriceResult {
        if (!subtotal || !partitionPrice || !taxPercent) {
            return this.getDefaultResult();
        }

        return {
            price: this.calculateTaxSum(
                subtotal, partitionPrice, taxPercent, taxStatus,
                CostDealType,
            ),
            priceB2C: this.calculateTaxSum(
                subtotal, partitionPrice, taxPercent, taxStatus,
                B2CDealType,
            ),
            priceB2B: this.calculateTaxSum(
                subtotal, partitionPrice, taxPercent, taxStatus,
                B2BDealType,
            ),
        };
    }

    private calculateTaxSum(
        subtotal: IPricing,
        partitionPrice: IPricing,
        taxPercent: number,
        taxStatus: boolean,
        dealType: string,
    ) {
        if (taxStatus) {
            const currentSubtotalValue = subtotal.getSystemPrice(dealType).getValue()
            const taxSum = currentSubtotalValue * (taxPercent / 100);

            return taxPercent === 0 ? currentSubtotalValue : parseFloat(taxSum.toFixed(2))
        }

        const currentPartitionPrice = partitionPrice.getSystemPrice(dealType).getValue()
        const taxSum = currentPartitionPrice * (taxPercent / 100);

        return taxPercent === 0 ? currentPartitionPrice : parseFloat(taxSum.toFixed(2))
    }
}
